<template>
  <div id="msp" class="container-fluid m-0 p-0">
    <MatrizMenu />
    <div class="pl-2 pr-2">
      <div class="box-body bg-light matriz-peligro-content col-md-12" style="width: 100%">
        <div class="collapse show" id="msp-collapse">
          <form class="container-fluid" v-on:submit.prevent="add_process">
            <div class="row justify-content-start">
              <div class="col-md-4">
                <label class="color_letra mt-3">Nuevo Proceso: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Conjunto de actividades mutuamente relacionadas o que interactuan, los cuales transforman elementos de entrada en resultados"></i></span></label>
                <textarea v-model="proceso_peligro" class="form-control boton_texto" placeholder="Proceso del riesgo"
                  autocomplete="on" spellcheck="true"></textarea>
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-3">Zona/Lugar: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Cualquier espacio físico en el que se realicen actividades relaciondas con el trabajo, bajo el control de la organización"></i></span></label>
                <textarea v-model="zona_peligro" class="form-control boton_texto" placeholder="Zona del riesgo"
                  autocomplete="on" spellcheck="true"></textarea>
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-3">Actividades: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Actividad que forma parte o no de un proceso de la organización, y por ende está o no planificada y estandarizada"></i></span></label>
                <textarea v-model="actividad_peligro" class="form-control boton_texto" placeholder="Actividad del riesgo"
                  autocomplete="on" spellcheck="true"></textarea>
              </div>
            </div>

            <div class="row justify-content-around">
              <div class="col-md-4">
                <label class="color_letra mt-3">Tareas: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacion una o varias tareas que hacen parte de la actividad"></i></span></label>
                <textarea v-model="tarea_peligro" class="form-control boton_texto" placeholder="Actividad del riesgo"
                  autocomplete="on" spellcheck="true"></textarea>
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-3">Rutinario: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Determina si las tareas relacionadas en la casilla de tareas son Rutinarias o No Rutinarias. Si estas se encuantra mezcladas, se sugiere ingresarlas por separado"></i></span></label>
                <select class="form-control form-control-sm boton_texto" v-model="rutinario_peligro" required>
                  <option value="Si" selected>Sí</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <br />
            <div class="col-md-6">
              <label class="color_letra mt-3">* Campos Obligatorios.</label>
            </div>
            <div class="row justify-content-center">
              <button v-show="$store.state.msp_c_key" type="button" @click="terminar_centro_trabajo"
                class="btn btn-sm btn-form font-weight-bold">
                TERMINAR MATRIZ DE PELIGROS
              </button>
              <!-- <button v-if="$store.state.msp_c_key &&
                $store.state.global_privilegio_admin_registro_proceso.crear" type="submit"
                @click="es_guardar = true, siguiente_proceso = true" class="btn btn-sm btn-form font-weight-bold">
                SIGUIENTE PROCESO
              </button> -->
              <button type="submit" class="btn btn-sm btn-form font-weight-bold" @click="es_guardar = true"
                :disabled="!$store.state.msp_c_key">
                GUARDAR
              </button>
            </div>
          </form>
        </div>
        <div class="d-flex justify-content-end m-0 p-0">
          <a @click="collapsed = !collapsed" class="pb-0 mb-0" data-toggle="collapse" data-target="#msp-collapse"
            aria-expanded="false" aria-controls="collapseExample">
            <i :class="[collapsed ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']"></i>
          </a>
        </div>
      </div>
    </div>
    <Mtm />
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import MatrizMenu from "@/components/MatrizMenu.vue";
import Mtm from "@/components/Mtm.vue";
import Swal from "sweetalert2";
/* import NProgress from "nprogress";
import "nprogress/nprogress.css"; */

export default {
  name: "msp",

  components: {
    MatrizMenu,
    Mtm,
  },

  data() {
    return {
      collapsed: true,
      // VARIABLES REGISTRO DE PROCESO
      proceso_peligro: null,
      zona_peligro: null,
      actividad_peligro: null,
      tarea_peligro: "",
      rutinario_peligro: null,
      id_tareas_temp: null,
      id_proceso_temp: null,
      id_actividad_temp: null,
      id_zonas_temp: null,
      fecha_actual: "",
      c_key: "",
      c_key_cliente_iper: "",
      id_matriz: "",
      pagina_actual: 1,
      tabla_peligros_local: [],
      columns: [
        "proceso_riesgo",
        "zona",
        "actividad",
        "tarea",
        "rutinario_peligro",
        "identificar",
        "opciones",
      ],
      options: {
        headings: {
          proceso_riesgo: "Proceso Riesgo",
          zona: "Zona",
          actividad: "Actividad",
          tarea: "Tarea",
          rutinario_peligro: "Rutinario Peligro",
          identificar: "Identificar Peligros",
          opciones: "Opciones",
        },
        sortable: ["proceso_riesgo", "zona", "actividad", "tarea"],
        texts: {
          filter: "Filtrar",
          filterPlaceholder: "",
        },
      },

      es_guardar: false,
      siguiente_proceso: false,
    };
  },

  created() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    /* NProgress.start(); */
    this.$store.state.global_llenar_matriz_peligros = false;
    if (
      this.$store.state.msp_c_key &&
      this.$store.state.global_id_matriz_riesgo
    ) {
      const docRef = db
        .collection("matriz_riesgo")
        .doc(this.$store.state.global_id_matriz_riesgo);
      docRef
        .get()
        .then((doc) => {
          /* ID TEMPORALES */
          this.id_proceso_temp = doc.data().em_id_proceso;
          this.id_zonas_temp = doc.data().em_id_zona;
          this.id_actividad_temp = doc.data().em_id_acti;
          this.id_tareas_temp = doc.data().em_id_tareas;
          /* DATOS */
          this.proceso_peligro = doc.data().em_proceso;
          this.zona_peligro = doc.data().em_zona;
          this.actividad_peligro = doc.data().em_actividad;
          const tarea = doc.data().em_tarea;
          if (Array.isArray(tarea)) {
            this.tarea_peligro = tarea.map((i) => ` ${i}`).toString();
          } else {
            this.tarea_peligro = tarea;
          }
          const rutinario = doc.data().em_rutinario;
          if (rutinario == true) {
            this.rutinario_peligro = "Si";
          } else {
            this.rutinario_peligro = "No";
          }
        })
        .catch((error) => {
          console.log(
            "Error al obtener el documento para ser editado: ",
            error
          );
        });
    }

    this.c_key = this.$store.state.msp_c_key;
    this.c_key_cliente_iper = this.$store.state.msp_c_key_cliente_iper;
    this.fecha_hoy();
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;
    /* NProgress.done();
    NProgress.remove(); */
  },

  methods: {
    // FUNCIÓN PARA MOSTRAR LA FECHA ACTUAL
    fecha_hoy() {
      var n = new Date();
      // AÑO
      var y = n.getFullYear();
      // MES
      var m = n.getMonth() + 1;
      // DÍA
      var d = n.getDate();
      // ORDENAR
      this.fecha_actual = d + "/" + m + "/" + y;
    },

    terminar_centro_trabajo() {
      /* NProgress.start(); */
      this.limpiar();
      this.$store.commit("mutation_limpiar_globales");
      /* NProgress.done();
      NProgress.remove(); */
    },

    async add_process() {
      /* NProgress.start(); */
      if (this.es_guardar) {
        this.agregar_nuevo_proceso();
        /* this.$store.state.global_id_matriz_riesgo = ""; */
      } else {
        this.limpiar();
        this.$store.commit("mutation_limpiar_globales");
        /* this.$store.state.global_id_matriz_riesgo = ""; */
        this.$store.state.global_es_editar = false;
        this.$store.state.msp_es_proceso = false;
        /* NProgress.done();
        NProgress.remove(); */
      }
    },

    // FUNCIÓN PARA AGREGAR NUEVO PROCESO A LA BASE DE DATOS
    async agregar_nuevo_proceso() {
      if (
        this.$store.state.msp_c_key &&
        this.$store.state.global_id_matriz_riesgo
      ) {
        /* NProgress.start(); */
        const procesoRef = db.collection("proceso").doc(this.id_proceso_temp);
        const zonaRef = db.collection("zona").doc(this.id_zonas_temp);
        const actividadRef = db
          .collection("actividades")
          .doc(this.id_actividad_temp);
        const tareaRef = db.collection("tareas").doc(this.id_tareas_temp);
        let rutinario = this.rutinario_peligro;

        if (rutinario == "Si") {
          rutinario = true;
        } else {
          rutinario = false;
        }

        /* PROCESO */
        await procesoRef
          .update({
            em_proceso_riesgo: this.proceso_peligro,
          })
          .catch((error) => {
            console.log("Error editing proceso:", error);
          });

        /* ZONA */
        await zonaRef
          .update({
            em_zona: this.zona_peligro,
          })
          .catch((error) => {
            console.log("Error editing zona:", error);
          });

        /* ACTIVIDADES */
        await actividadRef
          .update({
            em_actividades: this.actividad_peligro,
          })
          .catch((error) => {
            console.log("Error editing actividad:", error);
          });

        /* TAREAS */
        await tareaRef
          .update({
            em_tareas: this.tarea_peligro,
            em_rutinario: rutinario,
          })
          .catch((error) => {
            console.log("Error editing tarea:", error);
          });

        /* ACTUALIZAR DOCUMENTO MATRIZ RIESGO */
        /* console.log(this.$store.state.global_id_matriz_riesgo); */
        await db.collection("matriz_riesgo").doc(this.$store.state.global_id_matriz_riesgo).update({
          em_proceso: this.proceso_peligro,
          em_zona: this.zona_peligro,
          em_actividad: this.actividad_peligro,
          em_tarea: this.tarea_peligro,
          em_rutinario: rutinario
        })
          .catch((error) => {
            console.log("Error al editar los datos del proceso: ", error);
          })
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Datos actualizados correctamente.",
          showConfirmButton: false,
          timer: 1500,
        });


        /* await db
          .collection("matriz_riesgo")
          .where("em_id_tareas", "==", this.id_tareas_temp)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              id_matriz = doc.id;
              db.collection("matriz_riesgo")
                .doc(id_matriz)
                .update({
                  em_proceso: this.proceso_peligro,
                  em_zona: this.zona_peligro,
                  em_actividad: this.actividad_peligro,
                  em_tarea: this.tarea_peligro,
                  em_rutinario: rutinario,
                })
                .catch((error) => {
                  console.log(
                    "Error editing p, z, a, t, r of matrices riesgo: ",
                    error
                  );
                });
            });
          })
          .catch(function (error) {
            console.log(
              "Error trying to find id-documents of matriz_riesgo: ",
              error
            );
          }); */
        /* NProgress.done();
        NProgress.remove(); */
      } else {
        /* NProgress.start(); */
        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        const newProcesoRef = db.collection("proceso").doc();
        const newProcesoId = newProcesoRef.id;

        db.collection("proceso")
          .doc(newProcesoId)
          .set({
            em_id_cliente: this.c_key,
            em_proceso_riesgo: this.proceso_peligro,
          })
          .then(() => {
            this.agregar_nueva_zona(newProcesoId);
          })
          .catch((error) => {
            console.error("Error writing proceso: ", error);
          });
      }
    },

    // FUNCIÓN PARA AGREGAR NUEVA ZONA A LA BASE DE DATOS
    agregar_nueva_zona(nuevo_proceso_id) {
      var newZonaRef = db.collection("zona").doc();
      var newZonaId = newZonaRef.id;

      db.collection("zona")
        .doc(newZonaId)
        .set({
          em_id_cliente: this.c_key,
          em_id_proceso: nuevo_proceso_id,
          em_zona: this.zona_peligro,
        })
        .then(() => {
          this.agregar_nueva_actividad(nuevo_proceso_id, newZonaId);
        })
        .catch((error) => {
          console.error("Error writing zona: ", error);
        });
    },

    // FUNCIÓN PARA AGREGAR NUEVA ACTIVIDAD A LA BASE DE DATOS
    agregar_nueva_actividad(nuevo_proceso_id, nueva_zona_id) {
      var newActividadRef = db.collection("actividades").doc();
      var newActividadId = newActividadRef.id;

      db.collection("actividades")
        .doc(newActividadId)
        .set({
          em_id_cliente: this.c_key,
          em_id_proceso: nuevo_proceso_id,
          em_id_zona: nueva_zona_id,
          em_actividades: this.actividad_peligro,
        })
        .then(() => {
          this.agregar_nueva_tarea(
            nuevo_proceso_id,
            nueva_zona_id,
            newActividadId
          );
        })
        .catch((error) => {
          console.error("Error writing actividad: ", error);
        });
    },

    // FUNCIÓN PARA AGREGAR NUEVA TAREA A LA BASE DE DATOS
    async agregar_nueva_tarea(
      nuevo_proceso_id,
      nueva_zona_id,
      nueva_actividad_id
    ) {
      var newTareaRef = db.collection("tareas").doc();
      var newTareaId = newTareaRef.id;
      let rutinario = this.rutinario_peligro;
      if (rutinario == "Si") {
        rutinario = true;
      } else {
        rutinario = false;
      }
      await db
        .collection("tareas")
        .doc(newTareaId)
        .set({
          em_id_cliente: this.c_key,
          em_id_proceso: nuevo_proceso_id,
          em_id_zona: nueva_zona_id,
          em_id_acti: nueva_actividad_id,
          em_tareas: this.tarea_peligro,
          em_rutinario: rutinario,
        })
        .then(() => {
          this.identificar_peligros(
            nuevo_proceso_id,
            this.proceso_peligro,
            nueva_zona_id,
            this.zona_peligro,
            nueva_actividad_id,
            this.actividad_peligro,
            newTareaId,
            this.tarea_peligro,
            rutinario
          );
        })
        .catch((error) => {
          console.error("Error writing tarea: ", error);
        });
      // ALERTA DE GUARDADO
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Datos guardados.",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    limpiar() {
      this.rutinario_peligro = null;
      this.proceso_peligro = null;
      this.zona_peligro = null;
      this.actividad_peligro = null;
      this.tarea_peligro = [];
    },

    async identificar_peligros(
      id_proceso_peligro,
      proceso,
      id_zona_peligro,
      zona,
      id_actividad_peligro,
      actividad,
      id_tareas,
      tarea,
      rutinario
    ) {
      const newMatrizRef = db.collection("matriz_riesgo").doc();
      const id_matriz = newMatrizRef.id;
      await db
        .collection("matriz_riesgo")
        .where("em_id_cliente", "==", this.$store.state.msp_c_key)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            this.$store.state.global_llenar_matriz_peligros = true;
          }
        });
      await db
        .collection("matriz_riesgo")
        .doc(id_matriz)
        .set({
          em_id_cliente_iper: this.$store.state.msp_c_key_cliente_iper,
          em_id_cliente: this.$store.state.msp_c_key,

          em_id_proceso: id_proceso_peligro,
          em_id_zona: id_zona_peligro,
          em_id_acti: id_actividad_peligro,
          em_id_tareas: id_tareas,

          em_fecha_registro: firebase.firestore.FieldValue.serverTimestamp(),
          em_fecha_editado: firebase.firestore.FieldValue.serverTimestamp(),

          em_proceso: proceso,
          em_zona: zona,
          em_actividad: actividad,
          em_tarea: tarea,
          em_rutinario: rutinario,

          em_id_peligro: "",
          em_id_subclasificacion: "",
          em_id_efectos_posibles: "",

          em_descripcion: "",
          em_clasificacion: "",
          em_tipo: "",

          em_efecto_posible: [],
          em_c_fuente: [],
          em_c_medio: [],
          em_c_individuo: [],
          em_antecedente: "",

          em_img_peligro: "",
          em_img_peligro2: "",

          em_nivel_eficiencia: "",
          em_nivel_exposicion: "",
          em_nivel_probabilidad: "",
          em_interpretacion: "",
          em_nivel_consecuencia: "",
          em_nivel_riesgo: "",
          em_interpretacion_nr: "",
          em_aceptabilidad: "",

          em_num_expuestos: 0,
          em_peor_consecuencia: "",

          em_eliminacion: [],
          em_sustitucion: [],
          em_controles_ing: [],
          em_controles: [],
          em_equipos: [],
        })
        .then(() => {
          /* if (this.$store.state.global_llenar_matriz_peligros) {
            eventBus.$emit("cargar_tabla");
          } */
          this.$store.state.mip_id_proceso = id_proceso_peligro;
          this.$store.state.mip_id_zona = id_zona_peligro;
          this.$store.state.mip_id_actividad = id_actividad_peligro;
          this.$store.state.mip_id_tareas = id_tareas;

          this.$store.state.mip_proceso = proceso;
          this.$store.state.mip_zona = zona;
          this.$store.state.mip_actividad = actividad;
          this.$store.state.mip_tarea = tarea;
          this.$store.state.mip_rutinario = rutinario;
          this.$store.state.msp_es_proceso = true;
          if (!this.siguiente_proceso) {
            this.$store.state.global_id_matriz_riesgo = id_matriz;
            this.$store.state.global_nuevo_peligro = true;
          }
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
      await this.limpiar();
      /* NProgress.done();
      NProgress.remove(); */

      if (!this.siguiente_proceso) {
        this.redirigir_ruta();
      } else {
        this.siguiente_proceso = false;
      }
    },

    redirigir_ruta() {
      const tap1 = document.querySelector("#msp-tab");
      tap1.classList.remove("active");
      tap1.setAttribute("aria-selected", false);

      const tap2 = document.getElementById("mip-tab");
      tap2.setAttribute("aria-selected", true);
      this.$router.push("/identificar_peligros");
    },

    toggleIcon() {
      let iconClass = document.getElementById("icon-collapse");

      if (iconClass.classList) {
        iconClass.classList.toggle("fa-chevron-up");
      } else {
        var classes = iconClass.className.split(" ");
        var i = classes.indexOf("fa-chevron-down");

        if (i >= 0) classes.splice(i, 1);
        else classes.push("fa-chevron-up");
        iconClass.className = classes.join(" ");
      }
    },
  },
};
</script>